// ============================================================
// statementFocus.ts — (D12) a one-shot hand-off from the bell to the case's
// Settlement section: "show this statement" (and, for the colleague-confirm
// alerts, open its Send window on e-signature, where the confirm / refuse
// box is). The bell sets it before navigating; StatementPanel takes it once
// its statements have loaded (or at once, when it is already on screen).
// ============================================================

export interface StatementFocus {
  caseId: string
  statementId: string
  // Open the Send window on "Send for e-signature" (the contact check).
  openEsign?: boolean
}

// A hand-off nobody took within 2 minutes (the section never opened) is dropped.
const MAX_AGE_MS = 120_000
let pending: (StatementFocus & { at: number }) | null = null
const listeners = new Set<() => void>()

// "<caseId>:<statementId>" (the notification's linkId) → its parts.
export const parseStatementLink = (linkId: string): { caseId: string; statementId: string } | null => {
  const i = linkId.indexOf(':')
  if (i <= 0 || i === linkId.length - 1) return null
  return { caseId: linkId.slice(0, i), statementId: linkId.slice(i + 1) }
}

// The colleague-confirm alerts open the Send window on e-signature.
export const OPENS_ESIGN_TYPES = new Set(['esign.confirm_request', 'esign.confirm_done', 'esign.confirm_refused'])

export const requestStatementFocus = (f: StatementFocus): void => {
  pending = { ...f, at: Date.now() }
  listeners.forEach((l) => l())
}
export const peekStatementFocus = (caseId: string): StatementFocus | null =>
  (pending && pending.caseId === caseId && Date.now() - pending.at < MAX_AGE_MS ? pending : null)
export const clearStatementFocus = (): void => { pending = null }
export const onStatementFocus = (l: () => void): (() => void) => {
  listeners.add(l)
  return () => { listeners.delete(l) }
}
